import './badgestep.less'

import requestService from 'mithril/request/request'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import React, {useEffect, useRef, useState} from 'react'
import {style} from 'util/style'
import {Step} from 'views/registration/step'
import {OnsiteStepInfo} from 'views/registration/steps/onsitestep'
import {Theme} from 'views/theme'

const request = requestService(window, Promise).request

const styles = style('badgestep', ['loader'])

export const BadgeStep: React.FC<{
	registration: RegistrationModel
	updateRegistration: (model: RegistrationModel) => void
}> = ({registration, updateRegistration}) => {
	const step = registration.allSteps.badge
	const [isPickedUp, setIsPickedUp] = useState(false)
	useInterval(() => {
		if (isPickedUp) return

		request({
			method: 'GET',
			url: `/api/badge-check/${registration.confirmation.token}`
		}).then(({checked}) => {
			if (checked) setIsPickedUp(true)
		})
	}, 1000)

	return (
		<Step step={step} hasFormSubmit={true}>
			<div {...styles('loader')}>
				{!isPickedUp && (
					<p>Waiting for the badge system to pick up the registrants info..</p>
				)}
				{!isPickedUp && (
					<div {...styles('loader-animation')}>
						<BadgeStepLoader />
					</div>
				)}
				{isPickedUp && (
					<p>The registrants info is retrieved by the badge system.</p>
				)}
				{isPickedUp && (
					<Theme.Button
						mod="purple"
						onClick={() => {
							updateRegistration(registration.clear())
						}}
					>
						Reset form
					</Theme.Button>
				)}
			</div>
			<OnsiteStepInfo registration={registration} mod="done" />
		</Step>
	)
}

export const BadgeStepLoader: React.FC = () => {
	return (
		<div {...styles.loader}>
			<div {...styles.loader('plane')} />
		</div>
	)
}

function useInterval(callback, delay) {
	const savedCallback: any = useRef()

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback
	}, [callback])

	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current()
		}
		if (delay !== null) {
			const id = setInterval(tick, delay)
			return () => clearInterval(id)
		}
	}, [delay])
}
